"use strict";

const MODAL_SELECTOR = "[data-newsletter-modal]";
const FORM_SELECTOR = "[data-newsletter-form]";
const NOTIFY_SELECTOR = "[data-newsletter-form-notify]";
const SUBMIT_SELECTOR = "[data-newsletter-form-submit]";
const TRIGGER_SELECTOR = "[data-newsletter-open], a[href='#newsletter']";

const AJAX_ACTION = "newsletter_action";
const AUTO_CLOSE_MS = 5000;

function setNotify(notify, type, message) {
    if (!notify) {
        return;
    }

    notify.className = "form-notify";

    if (type) {
        notify.classList.add(type);
    }

    notify.textContent = message || "";
}

function getModalInstance(modal) {
    if (!window.bootstrap?.Modal) {
        return null;
    }

    return window.bootstrap.Modal.getOrCreateInstance(modal);
}

function openNewsletterModal(modal, notify) {
    setNotify(notify, "", "");

    const instance = getModalInstance(modal);

    if (instance) {
        instance.show();
    }
}

function initNewsletter() {
    const modal = document.querySelector(MODAL_SELECTOR);
    const form = modal ? modal.querySelector(FORM_SELECTOR) : null;

    if (!modal || !form) {
        return;
    }

    const notify = form.querySelector(NOTIFY_SELECTOR);
    const submitButton = form.querySelector(SUBMIT_SELECTOR);
    let autoCloseTimer = null;

    document.addEventListener("click", (event) => {
        const trigger = event.target.closest(TRIGGER_SELECTOR);

        if (!trigger) {
            return;
        }

        event.preventDefault();
        openNewsletterModal(modal, notify);
    });

    modal.addEventListener("shown.bs.modal", () => {
        const firstField = form.querySelector("input:not([type=hidden]), select, textarea");

        if (firstField instanceof HTMLElement) {
            firstField.focus();
        }
    });

    modal.addEventListener("hidden.bs.modal", () => {
        if (autoCloseTimer) {
            window.clearTimeout(autoCloseTimer);
            autoCloseTimer = null;
        }

        form.reset();
        setNotify(notify, "", "");
    });

    form.addEventListener("submit", async (event) => {
        event.preventDefault();

        if (!window.WPURLS?.ajaxUrl) {
            return;
        }

        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }

        const defaultMessage = window.WPURLS.mail_message?.error || "";
        const sendingMessage = window.WPURLS.mail_message?.sending || "";

        if (submitButton) {
            submitButton.disabled = true;
        }

        setNotify(notify, "info", sendingMessage);

        const data = new FormData(form);
        data.append("action", AJAX_ACTION);

        try {
            const response = await fetch(window.WPURLS.ajaxUrl, {
                method: "POST",
                credentials: "same-origin",
                body: data,
            });

            const payload = await response.json();
            const isSuccess = Boolean(payload?.success);

            setNotify(notify, isSuccess ? "success" : "error", payload?.message || defaultMessage);

            if (isSuccess) {
                autoCloseTimer = window.setTimeout(() => {
                    const instance = getModalInstance(modal);

                    if (instance) {
                        instance.hide();
                    }
                }, AUTO_CLOSE_MS);
            }
        } catch (error) {
            setNotify(notify, "error", defaultMessage);
        } finally {
            if (submitButton) {
                submitButton.disabled = false;
            }
        }
    });
}

function init() {
    initNewsletter();
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
} else {
    init();
}
